import { useTranslation } from 'react-i18next';
import { Flex, VStack } from '@chakra-ui/react';
import { SectionCard } from '@themes/aegix';
import { DetailRow } from '../DetailRow';
import { EventMetrics as EventMetricsComponent } from '../EventMetrics';
import {
  accountedFromStats,
  unaccountedFromStats,
  type ReunificationEventDetail,
} from '../../../types/ReunificationTypes';

interface EventDetailOverviewProps {
  event: ReunificationEventDetail;
}

export function EventDetailOverview({ event }: EventDetailOverviewProps) {
  const { t } = useTranslation();
  return (
    <Flex direction="column" gap={4}>
      <SectionCard title={t('events.section.details', 'Details')}>
        <VStack align="stretch" gap={0}>
          <DetailRow label={t('common.school', 'School')} value={event.school_name} dataE2e="event-detail-school" />
          <DetailRow label={t('events.detail.incidentType', 'Incident Type')} value={event.incident_type_display} dataE2e="event-detail-incident-type" />
          <DetailRow label={t('events.detail.plan', 'Plan')} value={event.plan_name ?? '---'} dataE2e="event-detail-plan" />
          <DetailRow
            label={t('events.detail.primarySite', 'Primary Site')}
            value={event.primary_site_name ?? '---'}
            dataE2e="event-detail-primary-site"
          />
          <DetailRow label={t('common.status', 'Status')} value={event.status_display} dataE2e="event-detail-status" />
          <DetailRow
            label={t('events.col.started', 'Started')}
            value={
              event.started_at
                ? new Date(event.started_at).toLocaleString()
                : '---'
            }
            dataE2e="event-detail-started"
          />
        </VStack>
      </SectionCard>

      <SectionCard title={t('events.section.statistics', 'Statistics')}>
        <VStack align="stretch" gap={0}>
          <DetailRow
            label={t('events.stat.studentsAccounted', 'Students (Accounted / Total)')}
            value={`${accountedFromStats(event.stats)} / ${event.stats.total_students}`}
            dataE2e="event-stat-students"
          />
          <DetailRow
            label={t('events.stat.reunified', 'Reunified')}
            value={String(event.stats.students_reunified)}
            dataE2e="event-stat-reunified"
          />
          <DetailRow
            label={t('events.stat.missing', 'Missing')}
            value={String(event.stats.students_missing)}
            dataE2e="event-stat-missing"
          />
          <DetailRow
            label={t('events.stat.medical', 'Medical')}
            value={String(event.stats.students_medical)}
            dataE2e="event-stat-medical"
          />
          <DetailRow
            label={t('events.stat.unaccounted', 'Unaccounted')}
            value={String(unaccountedFromStats(event.stats))}
            dataE2e="event-stat-unaccounted"
          />
        </VStack>
      </SectionCard>

      <SectionCard title={t('events.section.liveMetrics', 'Live Metrics')}>
        <EventMetricsComponent eventId={event.public_id} />
      </SectionCard>
    </Flex>
  );
}
